import { render, staticRenderFns } from "./bill.vue?vue&type=template&id=21badb2c&scoped=true"
import script from "./bill.vue?vue&type=script&lang=js"
export * from "./bill.vue?vue&type=script&lang=js"
import style0 from "./bill.vue?vue&type=style&index=0&id=21badb2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21badb2c",
  null
  
)

export default component.exports